import React from 'react';
import find from 'lodash/find';
import { SortableHandle } from 'react-sortable-hoc';

import { theme } from '../theme';
import {
  formatColumnPath,
  formatColumnAttribute,
  formatColumnHeaderText,
} from 'components/FieldColumns/columnHeader';

const DragHandle = SortableHandle(() => (
  <div style={theme.sortableIcon}>::</div>
));

const HeaderCell = ({
  onSortData,
  onFilterDialogOpen,
  column,
  sortColumnIndex,
  sortIcon,
  filters,
  width,
  colIndex,
  withOrdering,
  withFiltration,
  withSorting,
  showHierarchy,
}) => {
  const currentFilter = find(filters, (item) => item.index === column.index);
  const paddingLeft = colIndex === 0 ? 8 : 0;
  const isSorted = column.index === sortColumnIndex;
  const hierarchyPath = formatColumnPath(column);
  const attributeLabel = formatColumnAttribute(column);
  const headerText = formatColumnHeaderText(column);

  return (
    <div
      className={`header-cell ${!withOrdering ? 'without-ordering' : ''} ${colIndex === 0 ? 'first-column' : ''} ${showHierarchy ? 'header-cell--with-hierarchy' : ''} ${isSorted ? 'header-cell--sorted' : ''}`}
      style={{ width, paddingLeft }}
    >
      {withOrdering && <DragHandle />}
      <div
        className="header-cell-info"
        title={headerText}
        onClick={() => {
          if (withSorting) {
            onSortData(column.index);
          }
        }}
        style={isSorted ? theme.active : theme.headerTitle}
      >
        {showHierarchy &&
          (hierarchyPath ? (
            <span className="preview-table-column-hierarchy">
              {hierarchyPath}
            </span>
          ) : (
            <span className="preview-table-column-hierarchy-spacer" />
          ))}
        <div className="header-cell-title-row">
          <span className="header-cell-title">{column.name}</span>
          {attributeLabel && (
            <span className="header-cell-attribute">{attributeLabel}</span>
          )}
        </div>
      </div>
      {/* Source order is visual order: the sort arrow sits against the title,
          the filter icon outboard of it. Only the sorted column renders an
          arrow, and only that column is widened to hold one (see
          applySortAllowance in ScrollableTable.js) -- so no column carries a
          gap for an arrow it does not have, and gaining one truncates nothing. */}
      <div className="header-cell-actions">
        {withSorting && isSorted && (
          <div
            className="header-cell-sort"
            style={theme.active}
            onClick={() => onSortData(column.index)}
          >
            <i className="material-symbols-outlined" style={{ fontSize: 16 }}>
              {sortIcon === 'arrow-down' ? 'arrow_downward' : 'arrow_upward'}
            </i>
          </div>
        )}

        {withFiltration && (
          <div
            className="header-cell-filter"
            onClick={(e) => {
              if (e) {
                e.stopPropagation();
                const rect = e.currentTarget.getBoundingClientRect();
                onFilterDialogOpen(column, rect);
              }
            }}
          >
            <i
              className="material-symbols-outlined"
              style={{ fontSize: 16, color: currentFilter ? theme.active.color : theme.filter.color }}
            >filter_alt</i>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderCell;
